import React, { useState, useEffect, useRef } from 'react';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { ScrollPanel } from 'primereact/scrollpanel';
import { AuthApiService } from '../../../services/AuthApiService';
import { Toast } from 'primereact/toast';
import { getAndCleanDevice, getDeviceType } from './util';
import MFAPhone from './MFAPhone';
import MFAEmail from './MFAEmail';
import MFAApp from './MFAApp';
import {publishService} from './publishService';
import './MultiFactorAuth.css';
import utils from '../../../utils'
import Cookies from "universal-cookie";
import { Oval } from  'react-loader-spinner'
let subscription;
const MultiFactorAuth = () => {
  // Accordion
  const [phoneExpand, setPhoneExpand] = useState(false);
  const [emailExpand, setEmailExpand] = useState(false);
  const [authExpand, setAuthExpand] = useState(false);

  // User info
  const [id, setId] = useState('');
  const [userRefId, setUserRefId] = useState('');
  const [formattedName, setFormattedName] = useState('');
  const [primaryEmail, setPrimaryEmail] = useState('');


  // Auth App
  const [mobileAppIsEnabled, setMobileAppIsEnabled] = useState(false);
  const [appDeviceId, setAppDeviceId] = useState('');
  const [mobileAppDeviceName, setMobileAppDeviceName] = useState('');

  // Auth phone
  const [myMobilePhone, setMyMobilePhone] = useState('');
  const [phoneDeviceId, setPhoneDeviceId] = useState('');

  // Auth email
  const [emailIsEnabled, setEmailEnabled] = useState(false);
  const [email, setEmail] = useState('');
  const [emailDeviceId, setEmailDeviceId] = useState('');
  const [showLoading,setShowLoading] = useState(true)

  // Default device
  const [mfaStatus, setMfaStatus] = useState('');

  // Other
  const [isLoading, setIsLoading] = useState(false);

  const toast = useRef(null);
  const _apiService = new AuthApiService();



  /* Backend integration alternative */

  const create_UUID = ()=>{
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    //this.setState({idcsSessionId : uuid});
    return uuid;
  }
  
  const callOauth = ()=> {
    // const hostUrl = window.location.protocol+'//'+window.location.host;
    //window.location.href = hostUrl +`/accountmanagement/oauthadmin/login?spa-name=sso_idcsadmin&session-id=${create_UUID()}`;
  }

  const oauth2AdminLogin = ()=>{
    //changed to sessionstorage from localstorage
    const cookies = new Cookies();
    if(sessionStorage.getItem('login_flag') !== 'Y'&&cookies.get('share_dev_login_flag')!=='Y'){
      console.log('calling inside oauth');
      callOauth();
      sessionStorage.setItem('login_flag', 'Y');
  
      utils.setShareLoginFlagCookie('Y')
      //this.setState({login_flag : 'Y'})
    
    } else {
      console.log('not calling oauth');
      getUserAndDeviceInfo();
    }
  
  }

  /* For local testing */
  /*useEffect(() => {
    getUserAndDeviceInfo();
  }, []);
  */
  
  /* For server testing */
  
  useEffect(() => {
    oauth2AdminLogin();
  }, []);
  
  

  const handlePhoneExpand = () => {
    setPhoneExpand((prevState) => !prevState);
    setEmailExpand(false)
    setAuthExpand(false)
  };

  const handleEmailExpand = () => {
    setEmailExpand(prevState => !prevState);
    setPhoneExpand(false)
    setAuthExpand(false)
  };

  const handleAuthExpand = () => {
    setAuthExpand(prevState => !prevState)
    setPhoneExpand(false)
    setEmailExpand(false)
  };



  const getUserAndDeviceInfo = async () => {
    const [email, authApp, phone, userInfo] = await Promise.all([
      await _apiService.getMyDeviceInfoByFilter('EMAIL'),
      await _apiService.getMyDeviceInfoByFilter('TOTP'),
      await _apiService.getMyDeviceInfoByFilter('SMS'),
      await _apiService.getMeUserInfos()
    ]);

    const emailInfo = getAndCleanDevice(email.Resources);
    const appInfo = getAndCleanDevice(authApp.Resources);
    const phoneInfo = getAndCleanDevice(phone.Resources);
    const defaultDeviceId = userInfo['urn:ietf:params:scim:schemas:oracle:idcs:extension:mfa:User']?.preferredDevice?.value;

    // Set user related state
    if (userInfo) {
      setId(userInfo.id);
      setUserRefId(userInfo.userName);
      setFormattedName(userInfo.name.formatted);
      /* only email with primary=true should be considered as primary for MFA */
      var currentEmail;
      if(userInfo.emails) {
        userInfo.emails.filter(email => email.primary == true).map(primaryEmail => {
          currentEmail = primaryEmail.value
          setPrimaryEmail(primaryEmail.value)
        })

        if(!currentEmail){
          userInfo.emails.filter(email => email.pendingVerificationData).map(primaryEmail => {
            currentEmail = primaryEmail.value
            setPrimaryEmail("")
        })
        }

      }
      setShowLoading(false)
    }

    // Set email related state
    if (emailInfo && currentEmail) {
      setEmailEnabled(true);
      setEmail(currentEmail);
      setEmailDeviceId(emailInfo.id);

    }else {

      setEmailEnabled(false);
      setEmail('');
      setEmailDeviceId('');
    }

    // Set auth app related state
    if (appInfo) {
      setMobileAppIsEnabled(true);
      setAppDeviceId(appInfo.id);
      setMobileAppDeviceName(appInfo.displayName);
    }
    else {
      setMobileAppIsEnabled(false);
      setAppDeviceId('');
      setMobileAppDeviceName('');
    }

    // Set phone related state
    if (phoneInfo) {
      setMyMobilePhone(phoneInfo.phoneNumber);
      setPhoneDeviceId(phoneInfo.id);
    }
    else {
      setMyMobilePhone('');
      setPhoneDeviceId('');
    }

    // Set default MFA device
    const device = getDeviceType(defaultDeviceId, emailInfo?.id, appInfo?.id, phoneInfo?.id);
    setMfaStatus(device);


  };

  useEffect(() => {
    subscription = publishService.getAction().subscribe(obj => {
          if(obj.action==='success'){
              getUserAndDeviceInfo()
          }
        });
        return () => {
            subscription.unsubscribe();
        }
      }, [])
  const updateDeviceDefault = async (deviceType, deviceId) => {
    const data = {
      schemas: ['urn:ietf:params:scim:api:messages:2.0:PatchOp'],
      Operations: [
        {
          op: 'replace',
          path: 'urn:ietf:params:scim:schemas:oracle:idcs:extension:mfa:User:preferredAuthenticationFactor',
          value: deviceType,
        },
        {
          op: 'replace',
          path: 'urn:ietf:params:scim:schemas:oracle:idcs:extension:mfa:User:preferredDevice',
          value: {
            value: deviceId,
          },
        },
      ],
    };

    const result = await _apiService.patchUpdateEmail(data);

    if (!result || result.error) {
      console.log('update defailt failed');
      updateError(result.error);
    }
    else {
      updateSuccess('Your preferred authentication method has been updated');
    }
  }

  const deviceRemoved = async (id, message) => {
    const res = await _apiService.deleteMyDevice(id);

    // Success response is empty
    if (res && res.error) {
      updateError(res.error);
    }
    else {
      updateSuccess(message);
    }
  }

  const updateSuccess = (message) => {
    getUserAndDeviceInfo(); // Reload data after success update
    toast.current.show({
      severity: 'success',
      summary: 'Success',
      detail: message,
      life: 5000
    });
  };

  const updateError = (message) => {
    toast.current.show({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  };

  return (
    <div className="rightside-container">
      <ScrollPanel className="rightside-body px-2 md:px-6">
        <div className="flex flex-column align-items-center">
          <h3>Two-step Verification</h3>
          <span>
            Two-step verification adds an additional layer of security by using a second device to verify your identity.
          </span>
          <Divider className="py-3"/>
          {showLoading ?  null :<Tag
            className="d-flex justify-content-start w-full mr-2 bg-blue-100 py-2 px-3 text-sm text-black-alpha-90"
            severity="info"
            value="Adding a second verification method and setting the phone number as a default is highly recommended."
          />}
        </div>
        {showLoading ? 
        <div className="loader-container">
        <Oval
          height="34"
          width="34"
          color='rgb(0, 111, 207)'
          secondaryColor='rgb(0, 111, 207)'
          ariaLabel='loading'
        />
      </div>
        : <div className="pt-5">
          <MFAEmail
            emailExpand={emailExpand}
            emailIsEnabled={emailIsEnabled}
            userId={id}
            userName={userRefId}
            id={emailDeviceId}
            email={email}
            primaryEmail={primaryEmail}
            mfaStatus={mfaStatus}
            handleEmailExpand={handleEmailExpand}
            updateDeviceDefault={updateDeviceDefault}
            deviceRemoved={deviceRemoved}
            updateSuccess={updateSuccess}
            updateError={updateError}
          />

          <MFAPhone
            phoneExpand={phoneExpand}
            userId={id}
            userName={userRefId}
            userFormattedName={formattedName}
            myMobilePhone={myMobilePhone}
            id={phoneDeviceId}
            mfaStatus={mfaStatus}
            handlePhoneExpand={handlePhoneExpand}
            updateDeviceDefault={updateDeviceDefault}
            deviceRemoved={deviceRemoved}
            updateSuccess={updateSuccess}
            updateError={updateError}
          />

          <MFAApp
            authExpand={authExpand}
            userId={id}
            mfaStatus={mfaStatus}
            mobileAppIsEnabled={mobileAppIsEnabled}
            id={appDeviceId}
            deviceName={mobileAppDeviceName}
            handleAuthExpand={handleAuthExpand}
            updateDeviceDefault={updateDeviceDefault}
            deviceRemoved={deviceRemoved}
            updateSuccess={updateSuccess}
            updateError={updateError}
          />
        </div>}

      </ScrollPanel>
      <Toast ref={toast} className="responsive-toast" />
    </div>
  );
};

export default MultiFactorAuth;
